import * as types from '@/store/mutation-types';
import api from '@/store/api';
import { logAction } from '../logActions';
import moment from 'moment';
import log from '@/logger';

export const fetchPersons = async () => {
  return api.fetchPersons();
};

export const updateStatePersons = async ({ commit, state, dispatch }) => {
  const persons = await api.fetchPersons();
  const name = state.user.username.toLowerCase();

  // Seems like CouchDB sends us list of persons in undetermined order.
  // So we can't make an assumption about order of persons in the list.
  // We'll get the first person from the list with the most recent date of creation.
  const matchedPersons = Object.values(persons).filter(({ username }) => username.toLowerCase() === name);
  let loggedInPerson = matchedPersons.shift();
  if (matchedPersons.length) {
    let loggedInCreated = moment(loggedInPerson.createdAt);
    matchedPersons.forEach((person) => {
      const created = moment(person.createdAt);
      if (created.isAfter(loggedInCreated)) {
        loggedInPerson = person;
        loggedInCreated = created;
      }
    });
  }

  commit(types.setPersonList, persons);

  if (loggedInPerson) {
    commit(types.setLoggedInPerson, loggedInPerson);
    dispatch('updateLoginTime');
    dispatch('getPartCommentsForPerson', { personId: loggedInPerson._id }).then((comments) => {
      commit(types.setLoggedInUserPartComments, comments);
    });
  }

  // commit(types.setSyncStatus, { status: 'Active', live: 1, message: '', count: 1 });
  return persons;
};

export const preparePersonEntity = async () => {
  return api.preparePersonEntity();
};

export const savePerson = async ({ commit, state }, person) => {
  if (person._id) {
    return savePersonProperties({ commit, state }, { updatePerson: person, newPersonProperties: person });
  } else {
    return addPerson({ commit, state }, { newPersonProperties: person });
  }
};

export const addSyncedPerson = ({ commit }, person) => {
  commit(types.addPerson, { newPerson: person });
};

export const addPerson = async ({ commit, state }, addInfo) => {
  try {
    const person = await api.createPerson(addInfo.newPersonProperties || {});
    logAction({ commit, state }, { object: person, reason: 'Added Person' });
    commit(types.addPerson, { newPerson: person });

    return person;
  } catch (error) {
    log.error('personActions:addPerson', error);
    commit(types.setSyncStatus, {
      status: 'Error',
      live: 0,
      message: 'Database Error occurred while adding person',
      count: 1,
    });
  }
};

export const deletePerson = async ({ commit, state, dispatch }, { person }) => {
  await dispatch('savePersonProperties', {
    updatePerson: state.persons[person._id],
    newPersonProperties: { archived: true, username: '' },
  });
  commit(types.deletePerson, { person });
};

export const markMessagesRead = async ({ commit, state }) => {
  // Calling it directly because we need to bypass access check for some roles to allow self-update.
  return this.savePersonProperties(
    { commit, state },
    {
      updatePerson: state.loggedInPerson,
      newPersonProperties: { lastCommentReadDate: moment().format('YYYY-MM-DD HH:mm:ss') },
    }
  );
};

export const updateLoginTime = async ({ commit, state }) => {
  // Calling it directly because we need to bypass access check for some roles to allow self-update.
  return this.savePersonProperties(
    { commit, state },
    {
      updatePerson: state.loggedInPerson,
      newPersonProperties: { lastLoginDate: moment().format('YYYY-MM-DD HH:mm:ss') },
      reason: 'User logged in',
    }
  );
};

export const savePersonProperties = async ({ commit, state }, update) => {
  log.debug('personActions:savePersonProperties', update);
  logAction(
    { commit, state },
    { object: update.updatePerson, reason: 'Updated Person Properties', update: update.newPersonProperties }
  );
  setPersonProperties({ commit, state }, update);

  try {
    const savedPerson = await api.savePerson(update.updatePerson, update.reason);
    update.newPersonProperties = savedPerson;
    commit(types.setPersonProperties, update);
    commit(types.addPerson, { newPerson: update.updatePerson });

    return update.updatePerson;
  } catch (error) {
    const message = 'Database error occurred while saving person properties';
    log.error(message, error);
    commit(types.setSyncStatus, { live: false, status: 'Error', message, count: 1 });
    throw error;
  }
};

export const setPersonProperties = ({ commit }, update) => {
  commit(types.setPersonProperties, update);
};

export const syncPersonProperties = ({ commit, state }, update) => {
  commit(types.setPersonProperties, update);
  if (state.loggedInPerson && update.updatePerson._id === state.loggedInPerson._id) {
    commit(types.setLoggedInPerson, state.persons[update.updatePerson._id]);
  }
};

export const getPersonFiles = async (_unused, personId) => {
  return api.getPersonFiles(personId);
};

export const savePersonFile = async (_unused, { personId, name, file }) => {
  return api.savePersonFile(personId, name, file);
};

export const syncPersonFiles = async () => {
  // No need to update anything. Files are fetched when needed.
};



// WEBPACK FOOTER //
// ./src/store/person/personActions.js